export default function selectList(items, ids) {
  if (!ids) {
    return []
  }

  return ids.map(id => items[id])
}



// WEBPACK FOOTER //
// ../src/selectors/selectList.js